import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';

export interface HeaderLink {
   to: string;
   content: string;
}

export interface HeaderState {
   breadcrumbs: Array<{ to: string; content: string }>;
   tabs: Array<{ to: string; content: string }>;
}

const HeaderStore: Module<HeaderState, StoreState> = {
   namespaced: true,
   state: {
      breadcrumbs: [{ to: '/', content: 'NxtPlan' }],
      tabs: [],
   },
   getters: {
      breadcrumbs(state) {
         return state.breadcrumbs;
      },
      tabs(state) {
         return state.tabs;
      },
   },
   mutations: {
      SET_BREADCRUMBS(state, breadcrumbs) {
         state.breadcrumbs = [{ to: '/', content: 'NxtPlan' }, ...breadcrumbs];
      },
      SET_TABS(state, tabs) {
         state.tabs = tabs;
      },
   },
   actions: {},
};

export default HeaderStore;
